import { render, staticRenderFns } from "./EventTemplate.vue?vue&type=template&id=c0e9d080&"
import script from "./EventTemplate.vue?vue&type=script&lang=js&"
export * from "./EventTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports